export default __webpack_public_path__ + "static/AeroFIX_RWF-2.0-292cc480d88c2e9fdaeb36746587efed.jpg";